/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Member_Login_Method_Sso_DescriptionInputs */



/**
* | output |
* | --- |
* | "The member may sign in with their {provider} account." |
*
* @param {Member_Login_Method_Sso_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_method_sso_description = /** @type {((inputs: Member_Login_Method_Sso_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Method_Sso_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Mitglied darf sich mit seinem ${i?.provider}-Konto anmelden.`)
	return /** @type {LocalizedString} */ (`The member may sign in with their ${i?.provider} account.`)
});